export enum PerformanceSortFieldEnum {
  FULLNAME = 'fullName',
  NOTE = 'notes',
  CLICK_CALL = 'clickCalls',
  UPDATED_LEAD = 'updatedLeads',
  NO_UPDATED_LEAD = 'noUpdatedLeads',
  TASK = 'tasks',
  APPOINTMENT = 'appointments',
  LEAD_CREATED = 'createdLeads',
  POLICY_CREATED = 'createdPolicies',
  HOURS_ONLINE = 'hoursOnline'
}

export enum  LeadSortFieldEnum {
  FULLNAME = 'fullName',
  LEAD_MOVED = 'leadMoved',
  LEAD_TAKE_CARE = 'leadTakeCare',
  LEAD_CREATED = 'leadCreated',
  CUSTOMER = 'customer',
  PROSPECT = 'prospect',
  HIDDEN = 'hidden'
}

export enum NoteSortFieldEnum {
  LEAD_ID = 'lead.leadId',
  LEAD_NAME = 'lead.fullName',
  POLICY_NO = 'policy.number',
  OWNER = 'lead.owner.fullName',
  AGENT = 'lead.agent.fullName',
  CELLPHONE = 'lead.cellPhone',
  EMAIL = 'lead.email',
  ADDED_BY = 'createdBy.fullName',
  ADDED_DATE = 'createdAt',
  APPEND_DATE = 'updatedAt',
  NOTE_TYPE = 'status.name',
  NOTE = 'notes'
}

export enum ProductionSortFieldEnum {
  POLICY_NO = 'number',
  LEAD = 'lead.fullName',
  LEAD_ID = 'lead.leadId',
  CREATED_DATE = 'createdAt',
  OWNER = 'owner.fullName',
  AGENT = 'agent.fullName',
  POLICY_STATUS = 'status.name',
  POLICY_TRACKING = 'policyTracking.name',
  EFFECTIVE_DATE = 'effectiveDate',
  MODE = 'mode.name',
  PAYMENT = 'payment',
  FACE_AMOUNT = 'faceAmount',
  COMPANY = 'product.productType.company.name',
  PRODUCT_TYPE = 'product.productType.name',
  PRODUCT_NAME = 'product.name',
  CONTRIBUTION_YEAR = 'contributionYear',
  COMMISSION_TEAM = 'commissionTeam.name',
  COMMISSION_PERCENTAGE = 'commissionPercentage.name',
  COMMISSION_OWNER = 'commissionOwner.fullName',
  COMMISSION_AGENT = 'commissionAgent.fullName',
  CREATED_BY = 'createdBy.fullName',
  TARGET = 'target',
  EMAIL = 'lead.email',
  CELL_PHONE = 'lead.cellPhone',
  STATE = 'lead.state',
  DESCRIPTION = 'note'
}

export enum ReportTabEnum {
  PRODUCT = 'PRODUCT',
  PERFORMANCE = 'PERFORMANCE',
  LEAD = 'LEAD',
  NOTE = 'NOTE'
}

export enum ProductDetailExportFieldEnum {
  POLICY_NO = "POLICY_NO",
  LEAD = "LEAD",
  LEAD_ID = "LEAD_ID",
  CELLPHONE = "CELLPHONE",
  EMAIL = "EMAIL",
  STATE = "STATE",
  CREATED_DATE = "CREATED_DATE",
  OWNER = "OWNER",
  AGENT = "AGENT",
  POLICY_STATUS = "POLICY_STATUS",
  POLICY_TRACKING = "POLICY_TRACKING",
  EFFECTIVE_DATE = "EFFECTIVE_DATE",
  PREMIUM_MODE = "PREMIUM_MODE",
  PREMIUM_PAYMENT = "PREMIUM_PAYMENT",
  FACE_AMOUNT = "FACE_AMOUNT",
  COMPANY = "COMPANY",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  PRODUCT_NAME = "PRODUCT_NAME",
  CONTRIBUTION_YEARS = "CONTRIBUTION_YEARS",
  COMMISSION_TEAM = "COMMISSION_TEAM",
  COMMISSION_PERCENTAGE = "COMMISSION_PERCENTAGE",
  COMMISSION_OWNER = "COMMISSION_OWNER",
  COMMISSION_AGENT = "COMMISSION_AGENT",
  DESCRIPTION = "DESCRIPTION",
  CREATED_BY = "CREATED_BY",
  TARGET_PREMIUM = "TARGET_PREMIUM"
}

export enum PerformanceExportFieldEnum {
  USER = 'USER',
  NUMBER_OF_NOTES = 'NUMBER_OF_NOTES',
  NUMBER_OF_CLICK_CALLS = 'NUMBER_OF_CLICK_CALLS',
  NUMBER_OF_UPDATED_LEADS = 'NUMBER_OF_UPDATED_LEADS',
  NUMBER_OF_NO_UPDATED_LEADS = 'NUMBER_OF_NO_UPDATED_LEADS',
  NUMBER_OF_TASKS = 'NUMBER_OF_TASKS',
  NUMBER_OF_APPOINTMENTS = 'NUMBER_OF_APPOINTMENTS',
  TOTAL_LEADS_CREATED = 'TOTAL_LEADS_CREATED',
  TOTAL_POLICIES_CREATED = 'TOTAL_POLICIES_CREATED',
  HOURS_ONLINE = 'HOURS_ONLINE'
}

export enum LeadExportFieldEnum {
  USER = 'USER',
  TOTAL_LEADS_MOVED = 'TOTAL_LEADS_MOVED',
  TOTAL_LEADS_TAKE_CARE = 'TOTAL_LEADS_TAKE_CARE',
  TOTAL_LEADS_CREATED = 'TOTAL_LEADS_CREATED',
  CUSTOMER = 'CUSTOMER',
  PROSPECT = 'PROSPECT',
  HIDDEN = 'HIDDEN'
}

export enum NoteExportFieldEnum {
  LEAD_ID = 'LEAD_ID',
  LEAD_NAME = 'LEAD_NAME',
  POLICY_NO = 'POLICY_NO',
  OWNER = 'OWNER',
  AGENT = 'AGENT',
  ADDED_BY = 'ADDED_BY',
  CELL_PHONE = 'CELL_PHONE',
  EMAIL = 'EMAIL',
  ADDED_DATE = 'ADDED_DATE',
  LAST_NOTE = 'LAST_NOTE',
  TYPE_NOTE = 'TYPE_NOTE',
  NOTE = 'NOTE'
}

export interface ReportColumn {
  labelKey: string;
}

export interface ProductDetailsReportColumn extends ReportColumn {
  key: ProductDetailExportFieldEnum;
}

export interface PerformanceReportColumn extends ReportColumn {
  key: PerformanceExportFieldEnum;
}

export interface LeadReportColumn extends ReportColumn {
  key: LeadExportFieldEnum;
}

export interface NoteReportColumn extends ReportColumn {
  key: NoteExportFieldEnum;
}

export const productDetailsReportColumns: ProductDetailsReportColumn[] = [
  {
    key: ProductDetailExportFieldEnum.POLICY_NO,
    labelKey: 'policy.policy-no'
  },
  {
    key: ProductDetailExportFieldEnum.LEAD,
    labelKey: 'policy.lead'
  },
  {
    key: ProductDetailExportFieldEnum.LEAD_ID,
    labelKey: 'policy.lead-id'
  },

  {
    key: ProductDetailExportFieldEnum.CELLPHONE,
    labelKey: 'overview-detail.cellphone'
  },
  {
    key: ProductDetailExportFieldEnum.EMAIL,
    labelKey: 'overview-detail.email'
  },
  {
    key: ProductDetailExportFieldEnum.STATE,
    labelKey: 'overview-detail.state'
  },
  {
    key: ProductDetailExportFieldEnum.CREATED_DATE,
    labelKey: 'policy.created-date'
  },
  {
    key: ProductDetailExportFieldEnum.OWNER,
    labelKey: 'policy.owner'
  },
  {
    key: ProductDetailExportFieldEnum.AGENT,
    labelKey: 'policy.agent'
  },
  {
    key: ProductDetailExportFieldEnum.POLICY_STATUS,
    labelKey: 'policy.policy-status'
  },
  {
    key: ProductDetailExportFieldEnum.POLICY_TRACKING,
    labelKey: 'policy.policy-tracking'
  },
  {
    key: ProductDetailExportFieldEnum.EFFECTIVE_DATE,
    labelKey: 'policy.effective-date'
  },
  {
    key: ProductDetailExportFieldEnum.PREMIUM_MODE,
    labelKey: 'policy.premium-mode'
  },
  {
    key: ProductDetailExportFieldEnum.PREMIUM_PAYMENT,
    labelKey: 'policy.premium-payment'
  },
  {
    key: ProductDetailExportFieldEnum.FACE_AMOUNT,
    labelKey: 'policy.face-amount'
  },
  {
    key: ProductDetailExportFieldEnum.COMPANY,
    labelKey: 'policy.company'
  },
  {
    key: ProductDetailExportFieldEnum.PRODUCT_TYPE,
    labelKey: 'policy.product-type'
  },
  {
    key: ProductDetailExportFieldEnum.PRODUCT_NAME,
    labelKey: 'policy.product-name'
  },
  {
    key: ProductDetailExportFieldEnum.CONTRIBUTION_YEARS,
    labelKey: 'policy.contribution-years'
  },
  {
    key: ProductDetailExportFieldEnum.COMMISSION_TEAM,
    labelKey: 'policy.commission-team'
  },
  {
    key: ProductDetailExportFieldEnum.COMMISSION_PERCENTAGE,
    labelKey: 'policy.commission-percentage'
  },
  {
    key: ProductDetailExportFieldEnum.COMMISSION_OWNER,
    labelKey: 'policy.commission-owner'
  },
  {
    key: ProductDetailExportFieldEnum.COMMISSION_AGENT,
    labelKey: 'policy.commission-agent'
  },
  {
    key: ProductDetailExportFieldEnum.DESCRIPTION,
    labelKey: 'policy.description'
  },
  {
    key: ProductDetailExportFieldEnum.CREATED_BY,
    labelKey: 'policy.created-by'
  },
  {
    key: ProductDetailExportFieldEnum.TARGET_PREMIUM,
    labelKey: 'policy.target-premium'
  }
];

export const performanceReportColumns: PerformanceReportColumn[] = [
  {
    key: PerformanceExportFieldEnum.USER,
    labelKey: 'user'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_NOTES,
    labelKey: 'number-of-notes'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_CLICK_CALLS,
    labelKey: 'number-of-click-calls'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_UPDATED_LEADS,
    labelKey: 'number-of-updated-leads'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_NO_UPDATED_LEADS,
    labelKey: 'number-of-no-updated-leads'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_TASKS,
    labelKey: 'number-of-tasks'
  },
  {
    key: PerformanceExportFieldEnum.NUMBER_OF_APPOINTMENTS,
    labelKey: 'number-of-appointments'
  },
  {
    key: PerformanceExportFieldEnum.TOTAL_LEADS_CREATED,
    labelKey: 'total-leads-created'
  },
  {
    key: PerformanceExportFieldEnum.TOTAL_POLICIES_CREATED,
    labelKey: 'total-policies-created'
  },
  {
    key: PerformanceExportFieldEnum.HOURS_ONLINE,
    labelKey: 'hours-online'
  },
];

export const leadReportColumns: LeadReportColumn[] = [
  {
    key: LeadExportFieldEnum.USER,
    labelKey: 'user'
  },
  {
    key: LeadExportFieldEnum.TOTAL_LEADS_MOVED,
    labelKey: 'total-lead-moved'
  },
  {
    key: LeadExportFieldEnum.TOTAL_LEADS_TAKE_CARE,
    labelKey: 'total-leads-take-care'
  },
  {
    key: LeadExportFieldEnum.TOTAL_LEADS_CREATED,
    labelKey: 'total-leads-created'
  },
  {
    key: LeadExportFieldEnum.CUSTOMER,
    labelKey: 'customer'
  },
  {
    key: LeadExportFieldEnum.PROSPECT,
    labelKey: 'prospect'
  },
  {
    key: LeadExportFieldEnum.HIDDEN,
    labelKey: 'hidden'
  },
];

export const noteReportColumns: NoteReportColumn[] = [
  {
    key: NoteExportFieldEnum.LEAD_ID,
    labelKey: 'lead-id'
  },
  {
    key: NoteExportFieldEnum.LEAD_NAME,
    labelKey: 'lead-name'
  },
  {
    key: NoteExportFieldEnum.POLICY_NO,
    labelKey: 'policy-no'
  },
  {
    key: NoteExportFieldEnum.OWNER,
    labelKey: 'owner'
  },
  {
    key: NoteExportFieldEnum.AGENT,
    labelKey: 'agent'
  },
  {
    key: NoteExportFieldEnum.ADDED_BY,
    labelKey: 'added-by'
  },
  {
    key: NoteExportFieldEnum.CELL_PHONE,
    labelKey: 'cellphone'
  },
  {
    key: NoteExportFieldEnum.EMAIL,
    labelKey: 'email'
  },
  {
    key: NoteExportFieldEnum.ADDED_DATE,
    labelKey: 'added-date'
  },
  {
    key: NoteExportFieldEnum.LAST_NOTE,
    labelKey: 'last-note'
  },
  {
    key: NoteExportFieldEnum.TYPE_NOTE,
    labelKey: 'type-note'
  },
  {
    key: NoteExportFieldEnum.NOTE,
    labelKey: 'note'
  },
];